import { styled } from '@mui/system';
import {
	CircularProgress as MUICircularProgress,
} from '@mui/material';

export const CircularProgress = styled(MUICircularProgress)({
	position: 'absolute',
	right: '8px',
	width: '26px !important',
	height: '26px !important',
});
